import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["type", "children", "className", "align", "extraText", "extraTextComponentType", "isHeader", "inline", "onClose", "style", "tabIndex", "closeIconAriaLabel", "iconAriaProps", "iconRole", "hideScreenReaderMessage"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import classnames from 'classnames';
import { visuallyHidden } from '@mui/utils';
import { EmbersTypography } from '../typography/typography';
import { EmbersStatusIcon } from '../statusIcon/statusIcon';
import { StyledMessage, ROOT_PREFIX } from './messageStyles';
import { onEnterKeyPress } from '../utils/wcagUtils';
import { useIntl } from 'react-intl';
export var EmbersMessage = function EmbersMessage(_ref) {
  var _classnames;
  var type = _ref.type,
    children = _ref.children,
    className = _ref.className,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'left' : _ref$align,
    extraText = _ref.extraText,
    extraTextComponentType = _ref.extraTextComponentType,
    _ref$isHeader = _ref.isHeader,
    isHeader = _ref$isHeader === void 0 ? false : _ref$isHeader,
    _ref$inline = _ref.inline,
    inline = _ref$inline === void 0 ? false : _ref$inline,
    onClose = _ref.onClose,
    style = _ref.style,
    tabIndex = _ref.tabIndex,
    closeIconAriaLabel = _ref.closeIconAriaLabel,
    iconAriaProps = _ref.iconAriaProps,
    iconRole = _ref.iconRole,
    hideScreenReaderMessage = _ref.hideScreenReaderMessage,
    props = _objectWithoutProperties(_ref, _excluded);
  var intl = useIntl();
  var extraMessage;
  if (extraText) {
    extraMessage = /*#__PURE__*/React.createElement(EmbersTypography, {
      variant: "body",
      componentType: extraTextComponentType,
      className: 'EmbersMessage-extraText'
    }, extraText);
  }
  var closeBtn;
  if (inline && (type === 'success' || type === 'destructiveSuccess') && onClose) {
    closeBtn = /*#__PURE__*/React.createElement("div", {
      role: "button",
      className: "".concat(ROOT_PREFIX, "-close"),
      tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : 0,
      "aria-label": closeIconAriaLabel !== null && closeIconAriaLabel !== void 0 ? closeIconAriaLabel : intl.formatMessage({
        id: 'embers.iconLabel.close',
        defaultMessage: 'close'
      }),
      onClick: onClose,
      onKeyDown: function onKeyDown(e) {
        return onEnterKeyPress(e, onClose);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "icon-close"
    }));
  }
  var iconLabel;
  switch (type) {
    case 'success':
    case 'destructiveSuccess':
      iconLabel = intl.formatMessage({
        id: 'embers.statusIcon.success',
        defaultMessage: 'success'
      });
      break;
    case 'error':
      iconLabel = intl.formatMessage({
        id: 'embers.statusIcon.error',
        defaultMessage: 'error'
      });
      break;
    case 'alert':
      iconLabel = intl.formatMessage({
        id: 'embers.statusIcon.alert',
        defaultMessage: 'alert'
      });
      break;
    default:
      break;
  }
  var textContent = function textContent(elem) {
    if (!elem) {
      return '';
    }
    if (typeof elem === 'string') {
      return elem;
    }
    var children = elem.props && elem.props.children;
    if (children instanceof Array) {
      return children.map(textContent).join(' ');
    }
    return textContent(children);
  };
  var _iconAriaProps = {};
  if (iconAriaProps) {
    _iconAriaProps = _objectSpread(_objectSpread({}, iconAriaProps), {}, {
      'aria-label': iconAriaProps['aria-label'] !== undefined ? iconAriaProps['aria-label'] : iconLabel
    });
  } else {
    _iconAriaProps = {
      'aria-label': iconLabel
    };
  }
  return /*#__PURE__*/React.createElement(StyledMessage, {
    className: classnames("".concat(ROOT_PREFIX, "-root"), "".concat(ROOT_PREFIX, "-").concat(type), "".concat(ROOT_PREFIX, "-").concat(align), "".concat(ROOT_PREFIX, "-").concat(props.size), (_classnames = {}, _defineProperty(_classnames, "".concat(ROOT_PREFIX, "-inline"), inline), _defineProperty(_classnames, "".concat(ROOT_PREFIX, "-hasClose"), !!closeBtn), _defineProperty(_classnames, "".concat(ROOT_PREFIX, "-hasExtraText"), !!extraMessage && !inline), _classnames), className),
    style: style
  }, !hideScreenReaderMessage && /*#__PURE__*/React.createElement("div", {
    className: "EmbersMessage-sr-only",
    style: visuallyHidden,
    role: "alert",
    "aria-atomic": "true",
    "aria-live": "polite"
  }, "".concat(iconLabel, " ").concat(textContent(children), " ").concat(extraMessage ? textContent(extraMessage) : '')), /*#__PURE__*/React.createElement(EmbersStatusIcon, _extends({
    role: iconRole,
    type: type,
    variant: "filled",
    spacing: props.size === 'large' ? 8 : 4,
    className: classnames(_defineProperty({}, "".concat(ROOT_PREFIX, "-header"), isHeader || extraText))
  }, _iconAriaProps, props), children), closeBtn, !inline && extraMessage);
};